import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { X, Download, QrCode } from "lucide-react";

export function QRDialog({ open, onClose, url, title = "QR-Code" }) {
  const [dataUrl, setDataUrl] = useState("");

  useEffect(() => {
    if (!open || !url) return;
    QRCode.toDataURL(url, { width: 640, margin: 2, errorCorrectionLevel: "M" })
      .then(setDataUrl)
      .catch(() => setDataUrl(""));
  }, [open, url]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[10009] flex items-center justify-center p-4" data-testid="qr-dialog">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-xs p-5 text-center">
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm font-bold text-neutral-900 flex items-center gap-2 truncate">
            <QrCode className="h-4 w-4 text-neutral-500 shrink-0" /> <span className="truncate">{title}</span>
          </p>
          <button data-testid="qr-close" onClick={onClose} className="h-8 w-8 shrink-0 rounded-lg hover:bg-neutral-100 flex items-center justify-center text-neutral-400">
            <X className="h-4 w-4" />
          </button>
        </div>
        {dataUrl ? (
          <img src={dataUrl} alt="QR-Code" data-testid="qr-image" className="w-full rounded-xl border border-neutral-100" />
        ) : (
          <div className="h-56 flex items-center justify-center text-sm text-neutral-400">QR-Code wird erstellt…</div>
        )}
        <p className="text-[11px] text-neutral-400 mt-2 break-all">{url}</p>
        {dataUrl && (
          <a
            data-testid="qr-download"
            href={dataUrl}
            download={`qr-${(title || "code").toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40)}.png`}
            className="mt-3 w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-xl bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-800 transition"
          >
            <Download className="h-4 w-4" /> PNG herunterladen
          </a>
        )}
      </div>
    </div>
  );
}
